import axios from 'axios'

export function updateUserMapCenterAndZoomLevel(userId,formValues) {
  const formData = {
    user: { ...formValues },
  }
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_USER',
      payload: axios.patch(`/members/user_settings`, formData),
    })
  }
}

export function updateUserHomeLocation(formValues) {
  const formData = {
    user: {
      home_location_coords: { ...formValues },
    },
  }
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_USER',
      payload: axios.patch(`/members/user_settings`, formData),
    })
  }
}

export function updateUserDetails(formValues,callback){
  const formData = { ...formValues }
  formData['update_type'] = 'user_detail'
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_USER',
      payload: axios.put(`/members/user_detail`, formData).then((response) => {
        if(callback) callback(response.data);
      }),
    })
  }
}

export function referNewUser(formValues) {
  const formData = { referral: { ...formValues } }
  return (dispatch, getState) => {
    return dispatch({
      payload: axios.post("/members/referrals", formData),
    })
  }
}

export function acceptReferralInvitation(referralCode, formValues) {
  const formData = { referral: { ...formValues } }
  return (dispatch, getState) => {
    return dispatch({
      payload: axios.patch(`/members/referrals/${referralCode}`, formData),
    })
  }
}

export function fetchUserReferrals() {
  return (dispatch, getState) => {
    return dispatch({
      type: 'USER_REFERRALS_FETCH',
      payload: axios(`/members/referrals`)
    })
  }
}
